import { render, staticRenderFns } from "./panelScreenRenderer.vue?vue&type=template&id=59877378&scoped=true"
import script from "./panelScreenRenderer.vue?vue&type=script&lang=js"
export * from "./panelScreenRenderer.vue?vue&type=script&lang=js"
import style0 from "./panelScreenRenderer.vue?vue&type=style&index=0&id=59877378&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59877378",
  null
  
)

export default component.exports